"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _image = require("@site/pattern-library-core/image");
var _index = _interopRequireDefault(require("../../../elements/other/headline-lockup/index.js"));
var _customerCard = _interopRequireDefault(require("./customer-card"));
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _attribution = _interopRequireDefault(require("./attribution"));
/**
 * Local Imports
 */

const CustomerSectionContainer = /*#__PURE__*/(0, _react2.styled)(_section.default)({
  name: "CustomerSectionContainer",
  class: "pl-c15ughq5"
});
const Container = /*#__PURE__*/(0, _react2.styled)(_image.LazyBackgroundImage)({
  name: "Container",
  class: "pl-c8nhsk",
  vars: {
    "c8nhsk-7": [({
      portrait
    }) => portrait ? `url(${portrait})` : 'initial'],
    "c8nhsk-9": [({
      tablet
    }) => tablet ? `url(${tablet})` : 'initial']
  }
});
const HeadlineWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "HeadlineWrapper",
  class: "pl-hb7nl2n"
});
const AttributionBlock = /*#__PURE__*/(0, _react2.styled)("figcaption")({
  name: "AttributionBlock",
  class: "pl-a1hwuqqp"
});

/**
 * Customer Section Component.
 *
 * @param {Object} props React props
 * @param {String} props._name Tracking Name of the component
 * @param {String} props.heading Main Heading
 * @param {String} props.headlineSize Main Heading Size
 * @param {String} props.headlineTag Main Heading Tag
 * @param {Object} props.portrait Portrait Background Image
 * @param {Object} props.tablet Tablet Background Image
 * @param {Object} props.landscape Landscape Background Image
 * @param {String} props.attribution Background Image Attribution
 * @param {Object} props.cardImage Landscape Background Image
 * @param {String} props.cardHeading Card Heading
 * @param {String} props.cardAttribution Product List Attribution
 * @param {Array} props.productList Product List
 * @param {String} props.partial Theme partial
 * @param {String} props.attributionPartial Theme partial for attribution figcaption
 * @param {Boolean} props.invert Invert Flag
 * @param {String} props.verticalMargin Vertical Outer Spacing value
 * @param {String} props.verticalPadding Vertical Inner Spacing value
 * @returns {React.ReactElement} Customer Section Component
 * @public
 */
function CustomerSection({
  _name,
  heading,
  headlineSize = 'd3',
  headlineTag = 'h2',
  portrait,
  tablet,
  landscape,
  attribution,
  attributionHeadline,
  // New prop for headline
  attributionDescription,
  // New prop for description
  cardImage,
  cardHeading,
  cardAttribution,
  cardAttributionHeadline,
  cardAttributionDescription,
  productList,
  invert = false,
  attributionInvert = false,
  attributionPartial,
  verticalMargin = 'none',
  verticalPadding = 'none',
  partial,
  ...headlineProps
}) {
  const backgroundImages = {
    portrait: portrait?.url,
    tablet: tablet?.url,
    landscape: landscape?.url
  };
  return /*#__PURE__*/_react.default.createElement(CustomerSectionContainer, {
    dataCy: "customer-section",
    padding: "none",
    partial: partial,
    verticalMargin: verticalMargin,
    verticalPadding: verticalPadding,
    _name: _name
  }, heading && /*#__PURE__*/_react.default.createElement(HeadlineWrapper, {
    "data-cy": "main-headline-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_index.default, (0, _extends2.default)({
    textAlign: "start",
    heading: heading,
    headlineSize: headlineSize,
    headlineTag: headlineTag
  }, headlineProps))), /*#__PURE__*/_react.default.createElement(Container, (0, _extends2.default)({
    textAlign: "start",
    elementType: "div"
  }, backgroundImages), (attribution || attributionHeadline || attributionDescription) && /*#__PURE__*/_react.default.createElement(AttributionBlock, {
    "data-partial": attributionPartial || (attributionInvert ? 'dark1' : ''),
    "data-cy": "attribution"
  }, /*#__PURE__*/_react.default.createElement(_attribution.default, {
    attribution: attribution,
    attributionHeadline: attributionHeadline,
    attributionDescription: attributionDescription,
    formatLegacy: () => (0, _patternLibraryUtils.formatAttribution)(attribution, true),
    fontWeight: "initial"
  })), /*#__PURE__*/_react.default.createElement(_customerCard.default, {
    invert,
    partial,
    cardAttribution,
    cardAttributionHeadline,
    cardAttributionDescription,
    cardHeading,
    productList,
    cardImage,
    attribution,
    attributionInvert,
    attributionPartial
  })));
}
var _default = exports.default = CustomerSection;
CustomerSection.propTypes = {
  _name: _propTypes.default.string,
  heading: _propTypes.default.string,
  portrait: _propTypes.default.object,
  landscape: _propTypes.default.object,
  tablet: _propTypes.default.object,
  attribution: _propTypes.default.string,
  attributionHeadline: _propTypes.default.string,
  attributionDescription: _propTypes.default.string,
  attributionPartial: _propTypes.default.string,
  cardHeading: _propTypes.default.string,
  cardAttribution: _propTypes.default.string,
  cardAttributionHeadline: _propTypes.default.string,
  cardAttributionDescription: _propTypes.default.string,
  productList: _propTypes.default.array,
  partial: _propTypes.default.string,
  invert: _propTypes.default.bool,
  cardImage: _propTypes.default.object,
  attributionInvert: _propTypes.default.bool,
  ..._patternLibraryUtils.marginProps,
  ..._patternLibraryUtils.paddingProps
};